import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ItemHdrQueryCriteriaClass, ItemHdrCriteriaModelQuery } from '../../../criteria/item-hdr-criteria.model';
import { BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { FinancialItemLinkingContainerModel, FinancialItemLinkingQueryCriteria } from '../../../../../../models/aggregates/erp/financial-linking';

@Injectable({
  providedIn: 'root'
})
export class FinancialItemLinkingService extends BaseApiTemplateService<FinancialItemLinkingContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.ITEM_2_ITEM + Core2Config.CONFIG_PREFIX + 'fi-item-linking/login-guest-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.ITEM_2_ITEM + Core2Config.CONFIG_PREFIX + 'fi-item-linking/login-guest-ep';
    this.endpoint_path = Core2Config.ITEM_2_ITEM + Core2Config.CONFIG_PREFIX + 'fi-item-linking/login-guest-ep';
    this.httpClient = http;
  }

  public postItem(dtoObject: FinancialItemLinkingContainerModel, visa: ApiVisa
  ): Observable<BasicApiResponseModel<FinancialItemLinkingContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<FinancialItemLinkingContainerModel>>(

      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
